import React from 'react';
import { View, StyleSheet } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../../constants';
import BathroomsDetailViewCommon from './BathroomsDetailViewCommon';
/**
 * BathroomsDetailsViewWeb Component
 * 
 * This component renders the details of a bathroom specifically for a web environment.
 * It displays the hours of operation and location of a bathroom, making use of the DetailCommon component for the UI.
 * 
 * Props:
 *  - route: Contains parameters passed through the navigation stack, including the bathroom details.
 * 
 * @file BathroomsDetailsViewWeb.js
 * @module BathroomsDetailsViewWeb
 */
const BathroomsDetailsViewWeb = ({ route }) => {
    return (
        <View style={styles.container}>
            <BathroomsDetailViewCommon
                route={route}
                FontAwesomeIcon={FontAwesomeIcon}
                iconSize='lg'
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLORS.textLight,
        padding: 16,
    },
});

export default BathroomsDetailsViewWeb;
